const DITypes = {
  JsonRpcDispatcher: Symbol('OrderBookJsonRpcDispatcher'),
  DispatcherFactory: Symbol('OrderBookDispatcherFactory'),
  AdapterFactory: Symbol('OrderBookAdapterFactory'),
};

export default DITypes;
